import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum UserDetailsFormErrorStatesEnum {
    UserSearchFailed = ErrorStateScheduleEnum.UserDetailsFormStatesStartIndex,
    UserExists,
    UserCreationFailed
}
